import React, { useState, useEffect } from "react";
import HomepageTopbar from "../components/DesktopHomepage/HomepageTopbar";
import HomepageFooter from "../components/DesktopHomepage/HomepageFooter";
import MobileTopbar from "../components/MobileHomepage/MobileTopbar";
import MobileFooter from "../components/MobileHomepage/MobileFooter";
import { Outlet } from "react-router-dom";
import { TABWIDTH } from "../lib/constants";
import Loader from "../components/common/Loader";

const HomeLayout: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const windowWidth = window.innerWidth;
  const pathname = window.location.pathname.slice(1);

  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      if (newWidth !== windowWidth) {
        setLoading(true);
        // Force a reload to ensure topbar updates correctly
        setTimeout(() => {
          setLoading(false);
          // Optional: force re-render if needed
          window.dispatchEvent(new Event("resize"));
        }, 500);
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [windowWidth]);

  // Update scroll event listener
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      if (scrollPosition > 10) {
        // Check if scrolled more than 10px
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    // Add event listener
    window.addEventListener("scroll", handleScroll);

    // Initial check
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // useEffect to handle the window load event
  useEffect(() => {
    if (!loading) {
      setTimeout(() => {
        setLoading(false);
      }, 2500);
    }
  }, [loading]);

  return (
    <div
      className={`flex flex-col relative ${
        windowWidth < TABWIDTH ? "h-[100dvh]" : "h-[100vh]"
      } overflow-y-auto`}
      style={{
        msOverflowStyle: "none" /* IE and Edge */,
        scrollbarWidth: "none" /* Firefox */,
      }}
      onScroll={(e) => {
        const target = e.target as HTMLDivElement;
        setIsScrolled(target.scrollTop > 10);
      }}
    >
      {!loading && (
        <>
          {windowWidth < TABWIDTH ? (
            <MobileTopbar isScrolled={isScrolled} />
          ) : (
            <HomepageTopbar isScrolled={isScrolled} />
          )}
        </>
      )}

      <main className="flex-grow mb-7">
        <Outlet context={{ setLoading }} />
      </main>

      <footer
        className={`${
          windowWidth > TABWIDTH
            ? "pb-[1%]"
            : pathname !== "homepage"
            ? "relative -bottom-16"
            : ""
        }`}
      >
        {windowWidth < TABWIDTH ? <MobileFooter /> : <HomepageFooter />}
      </footer>
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex items-center justify-center bg-white z-50">
          <Loader />
        </div>
      )}
    </div>
  );
};

export default HomeLayout;
